import BackArrowIcon from 'assets/icons/back-arrow.svg';
import ModalTextField from 'components/ModalTextField';
import { ICalculateModalBodyProps } from 'interfaces/components/calculateModal';
import { DEPENDENCY_MAP } from 'utils/helpers/getDependencyMap';
import InfoIcon from 'assets/icons/info.svg';

const CalculateModalBody = ({
  fields,
  title,
  localStates,
  calculatedFields,
  nestedFieldsVisibility,
  handleToggleNestedFields,
  handleFieldChange,
  multipleCalculatedFields
}: ICalculateModalBodyProps) => {
  return (
    <div className='flex flex-col gap-6 max-h-[550px] overflow-y-auto'>
      {fields.map(field => {
        const fieldDependencyLabels = DEPENDENCY_MAP[field.name]?.labels;

        return nestedFieldsVisibility[field.name] && field.children ? (
          <div
            key={`nested-field-${field.name}`}
            className='p-4 border border-gray-400 rounded-lg'
          >
            <div className='flex flex-row items-center gap-2 mb-6'>
              <img
                src={BackArrowIcon}
                alt='Back Arrow'
                onClick={() => handleToggleNestedFields(field)}
                className='cursor-pointer'
              />
              <p className='text-[20px] leading-[19.2px] font-semibold'>
                {field.label}
              </p>
            </div>
            <div className='grid grid-cols-2 gap-6'>
              {field.children.fields.map(childField => {
                const childDependencyLabels =
                  DEPENDENCY_MAP[childField.name]?.labels;

                return (
                  <ModalTextField
                    key={`child-field-${field.name}-${childField.name}`}
                    label={childField.label}
                    name={childField.name}
                    value={localStates[childField.name] || ''}
                    onChange={value =>
                      handleFieldChange(childField.name, value)
                    }
                    placeholder={childField.placeholder}
                    tooltip={childField.tooltip}
                    character={childField.character}
                    isNumber={childField.isNumber}
                    isNegative={childField.isNegative}
                    forceNegativeSign={childField.forceNegativeSign}
                    isDecimal={childField.isDecimal}
                    isPrefixCharacter={childField.isPrefixCharacter}
                    useCommaFormat={childField.useCommaFormat}
                    min={childField.min}
                    max={childField.max}
                    infoIcon={InfoIcon}
                    showInfoIcon={childDependencyLabels?.length > 1}
                    tooltipListTitle='This change will affect the fields below.'
                    tooltipList={childDependencyLabels}
                  />
                );
              })}
              <div
                className={`${
                  field.children.fields.length % 2 === 0 ? 'col-span-2' : ''
                }`}
              >
                <ModalTextField
                  label={`Your ${field.label}`}
                  name={field.name}
                  value={calculatedFields[field.name] || ''}
                  onChange={() => {}}
                  placeholder={field.placeholder}
                  character={field.character}
                  isNumber={field.isNumber}
                  isNegative={field.isNegative}
                  useCommaFormat={field.useCommaFormat}
                  disabled
                  isDecimal={field.isDecimal}
                  isPrefixCharacter={field.isPrefixCharacter}
                  min={field.min}
                  max={field.max}
                />
              </div>
            </div>
          </div>
        ) : (
          <ModalTextField
            key={`main-field-${field.name}`}
            label={field.label}
            name={field.name}
            value={localStates[field.name] || ''}
            onChange={value => handleFieldChange(field.name, value)}
            placeholder={field.placeholder}
            tooltip={field.tooltip}
            character={field.character}
            isNumber={field.isNumber}
            isNegative={field.isNegative}
            forceNegativeSign={field.forceNegativeSign}
            isDecimal={field.isDecimal}
            isPrefixCharacter={field.isPrefixCharacter}
            useCommaFormat={field.useCommaFormat}
            showCalculateBtn={field.showCalculateBtn}
            onCalculateBtnClick={() => handleToggleNestedFields(field)}
            min={field.min}
            max={field.max}
            infoIcon={InfoIcon}
            showInfoIcon={fieldDependencyLabels?.length > 1}
            tooltipListTitle='This change will affect the fields below.'
            tooltipList={fieldDependencyLabels}
          />
        );
      })}
      {multipleCalculatedFields?.map(field => (
        <ModalTextField
          key={field.name}
          label={`Your ${field.fieldTitle || title}`}
          name={field.name}
          value={calculatedFields[field.name] || ''}
          onChange={() => {}}
          character={field.calculatedFieldCharacter}
          isPrefixCharacter={field.isPrefixCharacter}
          placeholder='0'
          infoIcon={InfoIcon}
          showInfoIcon={!!field.tooltipListTitle}
          tooltipListTitle={field.tooltipListTitle}
          isNumber={true}
          useCommaFormat={field.useCommaFormat}
          disabled
        />
      ))}
    </div>
  );
};

export default CalculateModalBody;
